import { render, staticRenderFns } from "./ClosureMovementTable.vue?vue&type=template&id=2046e66c&"
import script from "./ClosureMovementTable.vue?vue&type=script&lang=js&"
export * from "./ClosureMovementTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosureMovementTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
